import React from 'react';

function RenderScreeningData() {
  return <div>Render Screening HTML here.....</div>;
}

export default RenderScreeningData;
